const formatNotes = (notes: string) => {
  if (!notes?.length) {
    return '';
  }
  const urlRegex = /(https?:\/\/[^ ]+)/g;
  const alphaNumericRegex = /^[a-z0-9]+$/i;

  const newTransform = notes?.split(' ').map((word: string) => {
    // Prefix search for punctuation
    let i = 0;
    while (!alphaNumericRegex.test(word[i])) {
      i += 1;
    }

    // Postfix search for punctuation
    let j = word.length - 1;
    while (!alphaNumericRegex.test(word[j])) {
      j -= 1;
    }

    if (j > i) {
      const wordToTest = word.slice(i, j + 1);
      const prefix = word.slice(0, i);
      const postfix = word.slice(j + 1);
      return urlRegex.test(wordToTest) ? (
        <>
          &nbsp;
          {prefix}
          <a href={wordToTest} target="_blank" rel="noreferrer">
            {wordToTest}
          </a>
          {postfix}
        </>
      ) : (
        <>&nbsp;{word}</>
      );
    }
    return ' ' + word;
  });
  return newTransform;
};

export default formatNotes;
